import { render, staticRenderFns } from "./CardProfiles.vue?vue&type=template&id=c0ce1c82&"
import script from "./CardProfiles.vue?vue&type=script&lang=js&"
export * from "./CardProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports